// src/components/common/SidebarNav.js
import React, { useState } from 'react';
import { NAV_GROUPS } from '../../utils/constants';

function SidebarNav({ navItems, tab, setTab, notifCounts, isManager }) {
  const initOpen = () => {
    try {
      const saved = sessionStorage.getItem("nav_groups");
      if (saved) return JSON.parse(saved);
    } catch (e) {}
    return NAV_GROUPS.reduce((acc, g) => ({ ...acc, [g.key]: true }), {});
  };

  const [openGroups, setOpenGroups] = useState(initOpen);

  const toggleGroup = (key) => {
    setOpenGroups(prev => {
      const next = { ...prev, [key]: !prev[key] };
      try { sessionStorage.setItem("nav_groups", JSON.stringify(next)); } catch (e) {}
      return next;
    });
  };

  const badges = {
    expenses: notifCounts.expenses || 0,
    inventory: notifCounts.inventory || 0,
    pendingsales: notifCounts.sales || 0,
    ambassadors: notifCounts.withdrawals || 0,
    ambdash: notifCounts.newActivity || 0,
    settings: notifCounts.investorInterests || 0,
  };

  const renderItem = (n, isChild = false) => {
    const badge = badges[n.key] || 0;
    const parts = n.label.match(/^(\S+)\s(.+)$/);
    const icon = parts ? parts[1] : "•";
    const text = parts ? parts[2] : n.label;
    return (
      <button
        key={n.key}
        className={`nav-item${isChild ? " child" : ""}${tab === n.key ? " active" : ""}`}
        onClick={() => setTab(n.key)}
      >
        <span className="nav-icon">{icon}</span>
        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>{text}</span>
        {badge > 0 && <span className="nav-badge">{badge > 9 ? "9+" : badge}</span>}
      </button>
    );
  };

  if (!isManager) {
    return <>{navItems.map(n => renderItem(n))}</>;
  }

  const availableKeys = new Set(navItems.map(n => n.key));
  const rootItems = navItems.filter(n => !NAV_GROUPS.some(g => g.keys.includes(n.key)));

  return (
    <>
      {rootItems.map(n => renderItem(n))}
      {NAV_GROUPS.map(group => {
        const groupItems = group.keys.map(k => navItems.find(n => n.key === k)).filter(Boolean);
        if (groupItems.length === 0) return null;

        const groupBadge = groupItems.reduce((s, n) => s + (badges[n.key] || 0), 0);
        const isOpen = openGroups[group.key];
        const hasActive = groupItems.some(n => n.key === tab);

        return (
          <div key={group.key}>
            <button
              className={`nav-group-header${isOpen ? " open" : ""}`}
              onClick={() => toggleGroup(group.key)}
              style={hasActive && !isOpen ? { color: "#e94560" } : {}}
            >
              <span className="group-icon">{group.icon}</span>
              <span style={{ flex: 1 }}>{group.label}</span>
              {groupBadge > 0 && !isOpen && (
                <span className="group-badge">{groupBadge > 9 ? "9+" : groupBadge}</span>
              )}
              <span className="group-chevron">▼</span>
            </button>
            <div className={`nav-group-children${isOpen ? " open" : " closed"}`}>
              {groupItems.map(n => renderItem(n, true))}
            </div>
          </div>
        );
      })}
    </>
  );
}

export default SidebarNav;